angular.module('app').factory('userService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        return {
            getUserRoles: function () {
                return restAngular.
                    one("user/rolesCanBeCreated").
                    get()
            },
            createUser: function (user) {
                return restAngular.
                    one("user/create").
                    post("", user)
            },
            editUser: function (user) {
                return restAngular.
                    one("user/change").
                    post("", user)
            },
            getAllUsers: function (requestData) {
                return restAngular.
                    one("user/get").
                    customGET(param(requestData))
            },
            getUserById: function (userId) {
                return restAngular.
                    one("user/get").
                    customGET(param(userId))
            },
            deleteUserById: function (userId) {
                return restAngular.
                    one("user/delete").
                    customGET(param(userId))
            },
            login: function (loginInfo) {
                return restAngular.
                    one("User/login").
                    post("", loginInfo)
            },
            logout: function () {
                return restAngular.
                    one("User/logout").
                    post()
            },
            toggleItemInactive: function (pageId, title) {
                var requestObject = {
                    id: pageId,
                    status: title !== 'Publish' ? "inactive" : "published"
                };
                return restAngular.
                one("User/status").
                post("", {user: requestObject})
            },
            navigateToNewCms: function () {
                return restAngular.
                one("user/navigateToNewCms").
                get()
            }

        }
    }
]);
